import styled from 'styled-components';
import useStore from '../../store/useStore';
import { modelVersions } from '../../services/constants';
import { reuseTypes } from '../../services/parameters';
import { drainReuseKeys } from '../../services/constants';
import { reuseDrainwaterPossible } from '../../store/helpers';

const SettingsContainer = styled.div``;

const SubSettingsContainer = styled.div`
    padding-left: 16px;
`;

const ParameterDisplay = ({ label, value }) => {
    return (
        <div>
            <span>{label}</span>: <span>{value}</span>
        </div>
    );
};

const SelectListParameterDisplay = ({ label, options, value }) => {
    const selected = options.find((opt) => opt.value === value);
    const val = selected?.label ?? null;
    return <ParameterDisplay label={label} value={val} />;
};

const CheckboxParameterDisplay = ({ label, value }) => {
    const val = value ? 'Ja' : 'Nee';
    return <ParameterDisplay label={label} value={val} />;
};

const StartSettingsPrint = ({ modelVersion, className }) => {
    const { store, dispatch } = useStore();
    const {
        selectedCropParameter,
        selectedStage,
        selectedSubstrate,
        reuseDrainwaterValue,
        chlorineValue,
        summerWinter,
        ureumValue,
        dropWaterValue,
    } = store.input;

    const cropParameters = store.config?.cropList;
    if (!cropParameters) {
        return 'Loading...';
    }
    const cropOptions = cropParameters.map((param) => ({
        value: param.crop,
        label: param.crop,
    }));

    const substrateOptions =
        selectedCropParameter?.substrates?.map((substrate) => ({
            label: substrate.substrate,
            value: substrate,
        })) || [];

    const drainType = reuseDrainwaterValue.reuse
        ? drainReuseKeys.reuse
        : drainReuseKeys.free;

    let stageOptions = [];
    if (modelVersion === modelVersions.substraat) {
        if (
            selectedSubstrate &&
            selectedSubstrate.draintypeConfig[drainType] &&
            selectedSubstrate.draintypeConfig[drainType].phases
        ) {
            stageOptions = selectedSubstrate.draintypeConfig[
                drainType
            ].phases.map((stage) => ({
                label: stage,
                value: stage,
            }));
        }
    } else {
        if (selectedCropParameter && selectedCropParameter.cropStages) {
            stageOptions = selectedCropParameter.cropStages.map((stage) => ({
                label: stage,
                value: stage,
            }));
        }
    }

    const cropSelected = Boolean(selectedCropParameter?.crop);
    const substrateSelected = Boolean(selectedSubstrate);

    const drainReuseAvailable = reuseDrainwaterPossible({
        modelVersion,
        selectedCropParameter,
        selectedSubstrate,
    });

    const chlorineOptionAvailable = selectedSubstrate
        ? selectedSubstrate.chlorine
        : false;

    const summerWinterOptionAvailable = selectedCropParameter
        ? selectedCropParameter.summerWinterAvailable
        : false;

    return (
        <SettingsContainer className={className}>
            <ParameterDisplay
                label="Gewas"
                value={selectedCropParameter?.crop || ''}
            />

            {modelVersion === modelVersions.substraat && (
                <SelectListParameterDisplay
                    label="Substraat"
                    options={substrateOptions}
                    value={selectedSubstrate}
                />
            )}

            {Boolean(
                cropSelected &&
                    (modelVersion !== modelVersions.substraat ||
                        substrateSelected) &&
                    drainReuseAvailable
            ) && (
                <>
                    <ParameterDisplay
                        label="Hergebruik drainwater"
                        value={reuseDrainwaterValue.reuse ? 'Ja' : 'Nee'}
                    />

                    {Boolean(
                        reuseDrainwaterValue.reuse && drainReuseAvailable
                    ) && (
                        <SubSettingsContainer>
                            <ParameterDisplay
                                label={
                                    reuseTypes.fixed
                                        ? `Vast mengpercentage`
                                        : `EC regeling`
                                }
                                value={
                                    reuseDrainwaterValue.reuseType ===
                                    reuseTypes.fixed
                                        ? `${reuseDrainwaterValue.fixedPercentage} %`
                                        : `${reuseDrainwaterValue.EC} dS/m`
                                }
                            />
                        </SubSettingsContainer>
                    )}
                </>
            )}

            {modelVersion === modelVersions.substraat && (
                <ParameterDisplay
                    label="Gewasstadium"
                    value={
                        stageOptions.find((opt) => opt.value === selectedStage)
                            ?.label
                    }
                />
            )}

            {Boolean(
                modelVersion === modelVersions.potplant &&
                    cropSelected &&
                    stageOptions
            ) && (
                <SelectListParameterDisplay
                    label="Teeltfase"
                    id="Teeltfase"
                    options={stageOptions}
                    value={selectedStage}
                />
            )}

            {modelVersion === modelVersions.substraat &&
                chlorineOptionAvailable && (
                    <CheckboxParameterDisplay
                        label="Chlorine gebruik"
                        value={chlorineValue}
                    />
                )}
            {modelVersion === modelVersions.potplant && (
                <div>
                    <CheckboxParameterDisplay
                        label="Wordt ureum gebruikt in de druppeloplossing?"
                        value={ureumValue.used}
                    />
                    {ureumValue.used && (
                        <SubSettingsContainer>
                            <div>
                                <ParameterDisplay
                                    width={50}
                                    value={ureumValue.percentage}
                                />{' '}
                                %N-ureum van N-totaal
                            </div>
                            <div>
                                <ParameterDisplay
                                    width={50}
                                    value={ureumValue.drain}
                                />{' '}
                                ureum_drain
                            </div>
                        </SubSettingsContainer>
                    )}
                </div>
            )}
            <div>
                <ParameterDisplay
                    label="EC irrigatie"
                    width={50}
                    value={`${dropWaterValue} dS/m`}
                />
            </div>
            {modelVersion === modelVersions.potplant &&
                summerWinterOptionAvailable && (
                    <SelectListParameterDisplay
                        label="Zomer/winter"
                        options={[
                            { label: 'zomer', value: 'zomer' },
                            { label: 'winter', value: 'winter' },
                        ]}
                        value={summerWinter}
                    />
                )}
        </SettingsContainer>
    );
};

export default StartSettingsPrint;
